export const langMeteo = {
  fr: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Détails session',
    meteoDataLink: 'Données Vent',
    sessionHasNoMeteoData: "La session n'a pas de données Vent associées",
    sessionHasMeteoData: 'Des données Vent sont associées à la session',
    stationHasNoMeteoData:
      'La balise sélectionnée ne dispose pas de données Vent pour la session',
    stationHasMeteoData:
      'La balise sélectionnée dispose de données Vent pour la session',
    group: 'Lier les données Vent à la session',
    ungroup: 'Dissocier',
    title: 'Données Vent disponibles (rayon : ',
    altTitle: 'Autres données Vent disponibles (rayon : ',
    title2: ' km)',
    help: [
      `Vous pouvez associer à la session les données d'une balise winds.mobi proche du spot. L'application donne la liste des balises situées dans un rayon de 30 km, station dejà associée exclue.`,
      `Pour associer les données d'une balise, sélectionnez la balise puis cliquez sur 'Lier les données Vent à la session'.`,
      `Pour changer de balise associée, commencez par cliquer sur 'Dissocier' puis procédez comme indiqué ci-dessus.`,
    ],
    registeredUsers: `Réservé aux utilisateurs enregistrés`,
    beforeSession: `avant`,
    duringSession: `session`,
    afterSession: `après`,
    sourceFile: `Source : `,
    backToStats: `< Retour aux stats de la session`,
  },
  eng: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Session details',
    meteoDataLink: 'Wind datas',
    sessionHasNoMeteoData: 'Session has no associated Wind data',
    sessionHasMeteoData: 'Session has associated Wind data',
    stationHasNoMeteoData:
      'The selected weather station has no Wind data for the session',
    stationHasMeteoData:
      'The selected weather station has Wind data for the session',
    ungroup: 'Unlink',
    group: 'Link Wind data with session',
    title: 'Wind data available (radius: ',
    altTitle: 'Other Wind data available (radius: ',
    title2: ' km)',
    help: [
      `You can associate to the session the data of a station winds.mobi close to the spot. The application lists the stations within a 30 km radius, station already associated excluded.`,
      `To associate the data of a station, select the station and click 'Link Wind Data with Session'.`,
      `To change the associated station data, start by clicking on 'Unlink' and then proceed as above.`,
    ],
    registeredUsers: `Registered users only`,
    beforeSession: `before`,
    duringSession: `session`,
    afterSession: `after`,
    sourceFile: `Source : `,
    backToStats: `< Back to session stats`,
  },
}
